export const c = (...classNames: string[]) => classNames.filter(Boolean).join(' ');
